/** The HTMLSelectListEvent represents a item selection change, caused by the user or the html being re-rendered. */
export default class HTMLSelectListEvent extends Event {
	/**
	 * The static SELECTION_CHANGED property is used by the listeners, so we dont't get typo bugs.
	 *
	 * Example: addEventListener(HTLMSelectListEvent.SELECTION_CHANGED, (event: HTMLSelectListEvent<string>) => {});
	 */
	public static SELECTION_CHANGED = 'HTMLSelectListEvent.selectionChanged';
	/**
	 * The selectedItem is the item value if set in the html renderer.
	 *
	 * Or in other words, the item property value of the html-select-list-item-renderer that's currently selected.
	 */
	public selectedItem: unknown;

	public constructor(selectedItem: unknown = null) {
		super(HTMLSelectListEvent.SELECTION_CHANGED, { bubbles: true });
		this.selectedItem = selectedItem;
	}
}
